import { render, staticRenderFns } from "./invite_members_trigger.vue?vue&type=template&id=51a97790"
import script from "./invite_members_trigger.vue?vue&type=script&lang=js"
export * from "./invite_members_trigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports